import request from '@/utils/request'

// 定时任务列表
export function jobList() {
  return request({ url: '/api/schedule/job/list', method: 'get' })
}

// 新增任务
export function jobAdd(data) {
  return request({ url: '/api/schedule/job/add', method: 'post', data })
}

// 修改任务
export function jobUpdate(data) {
  return request({ url: '/api/schedule/job/update', method: 'post', data })
}

// 删除任务
export function jobDelete(id) {
  return request({ url: `/api/schedule/job/delete/${id}`, method: 'post' })
}

// 启动任务
export function jobStart(id) {
  return request({ url: `/api/schedule/job/start/${id}`, method: 'post' })
}

// 暂停任务
export function jobSuspend(id) {
  return request({ url: `/api/schedule/job/suspend/${id}`, method: 'post' })
}

// 立即触发
export function jobTrig(id) {
  return request({ url: `/api/schedule/job/trig/${id}`, method: 'post' })
}

// 任务日志分页
export function jobLogList(params) {
  return request({ url: '/api/schedule/job/log/list', method: 'get', params })
}
